<div id="backlog">
  <div class="column-headers">
    <div class="kanban-column board-column">
      <div>Backlog</div>
    </div>
  </div>

  <div class="backlog-filter">
    <mat-form-field>
      <input type="search" matInput placeholder="{{'components.kanbanBacklog.searchBySummary' | translate}}" [(ngModel)]="summaryFilter" (ngModelChange)="filter('summary' ,$event)" />
      <button mat-button *ngIf="summaryFilter" matSuffix mat-icon-button aria-label="Clear" (click)="summaryFilter=''; filter('summary','');">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title [translate]="'components.kanbanBacklog.advancedFilter'">
            Advanced Filters
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field>
          <mat-select placeholder="{{'components.kanbanBacklog.filterByAssignee' | translate}}" [(ngModel)]="selectedAssignee" (ngModelChange)="filter('assignee', $event)">
            <mat-option>{{'components.kanbanBacklog.showAll' | translate}}</mat-option>
            <mat-option *ngFor="let member of team" [value]="member.displayName">{{ member.displayName }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="{{'components.kanbanBacklog.filterByReporter' | translate}}" [(ngModel)]="selectedReporter" (ngModelChange)="filter('reporter', $event)">
            <mat-option>{{'components.kanbanBacklog.showAll' | translate}}</mat-option>
            <mat-option *ngFor="let member of team" [value]="member.displayName">{{ member.displayName }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="{{'components.kanbanBacklog.filterByIssuetype' | translate}}" [(ngModel)]="selectedIssuetype" (ngModelChange)="filter('issuetype', $event)">
            <mat-option>{{'components.kanbanBacklog.showAll' | translate}}</mat-option>
            <mat-option [value]="'story'">Story</mat-option>
            <mat-option [value]="'task'">Task</mat-option>
            <mat-option [value]="'bug'">Bug</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="{{'components.kanbanBacklog.filterByCreationOlderThan' | translate}}" [(ngModel)]="selectedCreationDate" (ngModelChange)="filter('created', $event)">
            <mat-option>{{'components.kanbanBacklog.showAll' | translate}}</mat-option>
            <mat-option [value]="'-14d'">{{'components.kanbanBacklog.14days' | translate}}</mat-option>
            <mat-option [value]="'-30d'">{{'components.kanbanBacklog.30days' | translate}}</mat-option>
            <mat-option [value]="'-60d'">{{'components.kanbanBacklog.2months' | translate}}</mat-option>
            <mat-option [value]="'-180d'">{{'components.kanbanBacklog.6months' | translate}}</mat-option>
            <mat-option [value]="'-365d'">{{'components.kanbanBacklog.1year' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>

        <button class="reset-filter" (click)="filter('clearAll', '')" mat-raised-button>
          {{'components.kanbanBacklog.resetAllFilters' | translate}}
        </button>

      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="kanban-row">
    <div class="new-user-story">
      <button class="new-userstory-button" (click)="openCreateUserStoryDialog()" mat-raised-button>
        {{'actionview.release-planning.addUserStory' | translate}}
      </button>
    </div>

    <div id="productbacklog" cdkDropList class="kanban-column issue-list board-column"
          [cdkDropListData]="backlogColumn"
          (cdkDropListDropped)="onDropBacklog($event)">
      <app-kanban-taskcard *ngFor="let task of tasks" [task]="task" class="issue-list-element" cdkDrag
                           [cdkDragData]="task"
                           [attr.data-taskcardid]="task.id"
                           (dblclick)="this.onIssueDoubleClicked($event, task)">
        <div *cdkDragPreview class="custom-drag-preview">
          <div class="issue-list-element">{{task.summary}}</div>
        </div>
      </app-kanban-taskcard>
    </div>
  </div>

</div>
